import { render, staticRenderFns } from "./WatSponsorProgramation.vue?vue&type=template&id=38955d14&"
import script from "./WatSponsorProgramation.vue?vue&type=script&lang=js&"
export * from "./WatSponsorProgramation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports